// Maps a platform's sentiment_label to a MUI Chip color, matching LiveSearchPage.
export const SENTIMENT_COLORS = { positive: 'success', neutral: 'default', negative: 'error', unknown: 'default' };

export const sentimentLabel = (value) =>
    value && value !== 'unknown' ? value.charAt(0).toUpperCase() + value.slice(1) : null;
